import React from 'react';
export function CTASection() {
  return <section id="contact" className="py-16 bg-[#3A4A46] text-white" data-id="element-163">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-164">
        <div className="max-w-3xl mx-auto text-center" data-id="element-165">
          <div className="flex justify-center mb-8" data-id="element-166">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/cxY6qWzHxoq8pm6btP29jY/White_Logo.png" alt="Meyer Bookkeeping & Tax Logo" className="h-20 w-auto" data-id="element-167" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-168">
            Ready to hand off your bookkeeping and tax needs with confidence?
          </h2>
          <p className="text-xl mb-8" data-id="element-169">
            <span className="block mb-2" data-id="element-170">
              Schedule your free discovery call today
            </span>
            <span className="block" data-id="element-171">
              and take the first step toward financial clarity.
            </span>
          </p>
          <a href="https://outlook.office.com/book/MeyerBookkeepingTax@meyerbkt.com/" target="_blank" rel="noopener noreferrer" className="inline-block bg-[#9BAB6C] text-white px-8 py-4 rounded-md text-lg font-medium hover:bg-opacity-90 transition-colors" data-id="element-172">
            Book a Free Discovery Call
          </a>
          <p className="mt-6 text-gray-300" data-id="element-173">
            No pressure, just a helpful conversation to see if we're a good fit.
          </p>
          <div className="mt-12 flex flex-col md:flex-row justify-center items-center space-y-4 md:space-y-0 md:space-x-8" data-id="element-174">
            <div className="flex items-center" data-id="element-175">
              <div className="h-10 w-10 rounded-full bg-[#8A9A5B] flex items-center justify-center mr-3" data-id="element-176">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor" data-id="element-177">
                  <path fillRule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd" data-id="element-178" />
                </svg>
              </div>
              <span data-id="element-179">Orange City, Iowa</span>
            </div>
            <div className="flex items-center" data-id="element-180">
              <div className="h-10 w-10 rounded-full bg-[#8A9A5B] flex items-center justify-center mr-3" data-id="element-181">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor" data-id="element-182">
                  <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" data-id="element-183" />
                  <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" data-id="element-184" />
                </svg>
              </div>
              <span data-id="element-185">info@meyerbkt.com</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}